import { Link } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { MarkupElement } from 'src/functions/formatElement.htmlAst';
import { StoriesListContainer, StoryEmptyText, StoryEntry, StoryEntryEmpty, StoryImage, StoryTitle } from './caseStudies.list.styles';

interface StoriesOfAwesomeListProps {
  posts: {
    title: string;
    image: IGatsbyImageData;
    description: {
      htmlAst: {
        type: string;
        children: MarkupElement[]
      }
    }
    slug: string;
  }[]
}

const StoriesOfAwesomeList = ({ posts }: StoriesOfAwesomeListProps): JSX.Element => {

  return (
    <StoriesListContainer>
      <StoryEntryEmpty>
        <StoryEmptyText>

          <svg xmlns="http://www.w3.org/2000/svg" width="111" height="43" viewBox="0 0 111 43" fill="none">
            <path d="M86.8709 12.0159L83.002 40.4922L110.738 16.7466L86.8709 12.0159Z" fill="#80D1CD" />
            <path d="M59.2443 12.0159L63.1133 40.4922L35.3768 16.7466L59.2443 12.0159Z" fill="#CD395C" />
            <path d="M3.70338 5.69387L21.426 33.1108L12.3441 41.6711L2.8318 40.2555L3.70338 5.69387Z" fill="#963481" />
          </svg>
          <Paragraph
            text="Explore all our Stories!"
            size="1.25em"
            sizeSubLg="1.125em"
            align="center"
            weight="light"
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="111" height="43" viewBox="0 0 111 43" fill="none">
            <path d="M23.8674 12.0159L27.7363 40.4922L-0.000159141 16.7466L23.8674 12.0159Z" fill="#80D1CD" />
            <path d="M51.494 12.0159L47.625 40.4922L75.3615 16.7466L51.494 12.0159Z" fill="#CD395C" />
            <path d="M107.035 5.69374L89.3123 33.1107L98.3942 41.671L107.906 40.2554L107.035 5.69374Z" fill="#963481" />
          </svg>
        </StoryEmptyText>
      </StoryEntryEmpty>
      {
        posts.map((post) => (
          <Link key={post.slug} to={`/case-studies/${post.slug}`}>
            <StoryEntry key={post.slug}>
              <StoryImage>
                <Image childImageSharp={ post.image } alt={post.title} />
              </StoryImage>
              <StoryTitle>
                <Heading
                  text={post.title}
                  size="1.125rem"
                />
              </StoryTitle>
            </StoryEntry>
          </Link>
        ))
      }
    </StoriesListContainer>
  )
}

export default StoriesOfAwesomeList;
